// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const Navbar = () => {
  const navigate = useNavigate();
  const { cart } = useCart();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (cart.length === 0) return;
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 300);
    return () => clearTimeout(timer);
  }, [cart.length]);

  // État d'authentification
  const isAuthenticated = !!localStorage.getItem('username');
  const role = localStorage.getItem('role');
  const username = localStorage.getItem('username');

  const handleLogout = async () => {
    try {
      await axios.post(`${API_BASE_URL}/auth/logout`);
    } catch (err) {
      console.error('Erreur lors de la déconnexion API', err);
    }
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    navigate('/login');
  };

  return (
    <nav className="bg-slate-900 text-slate-100 shadow-md border-b border-slate-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="text-xl font-bold tracking-tight text-indigo-400 hover:text-indigo-300 transition-colors">
            E-Shop Tech
          </Link>
        </div>

        <div className="flex items-center space-x-6 text-sm font-medium">
          {/* Badge utilisateur connecté */}
          {isAuthenticated && (
            <span className="text-slate-400 bg-slate-800 px-3 py-1.5 rounded-full text-xs">
              Connecté : <strong className="text-slate-200">{username}</strong> ({role})
            </span>
          )}

          {/* Lien Mes Commandes pour connecté */}
          {isAuthenticated && (
            <Link to="/my-orders" className="hover:text-indigo-400 transition-colors py-2">
              Mes commandes
            </Link>
          )}

          {/* Lien Dashboard pour admin */}
          {isAuthenticated && role === 'admin' && (
            <Link to="/admin" className="text-amber-400 hover:text-amber-300 transition-colors bg-amber-500/10 border border-amber-500/20 px-3 py-1.5 rounded-md">
              Dashboard Admin
            </Link>
          )}

          {/* Lien Panier */}
          <Link to="/cart" className="relative flex items-center space-x-1.5 hover:text-indigo-400 transition-colors py-2">
            <span>Panier</span>
            {cart.length > 0 && (
              <span className={`bg-indigo-600 text-white rounded-full text-xs font-bold w-5 h-5 flex items-center justify-center transition-all duration-300 ${animate ? 'scale-125 bg-amber-500 shadow-lg shadow-amber-500/40 rotate-12' : ''}`}>
                {cart.length}
              </span>
            )}
          </Link>

          {/* Auth boutons */}
          {!isAuthenticated ? (
            <div className="flex items-center space-x-4">
              <Link to="/login" className="hover:text-indigo-400 transition-colors">Connexion</Link>
              <Link to="/register" className="bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-md transition-all shadow-sm">
                Inscription
              </Link>
            </div>
          ) : (
            <button onClick={handleLogout} className="bg-rose-600/20 text-rose-400 hover:bg-rose-600/35 border border-rose-500/30 px-4 py-2 rounded-md transition-colors font-medium">
              Déconnexion
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
